<template>
    <div class="rel-serv-supplier-component">


        <form id="formCrud" class="formCrud">
            <ul class="row">
                <li class="col-12 col-sm-6 mb-2" v-for="(serv, index) in getServArray" :value="serv.id" :key="serv.id">
                    <strong>{{ serv.prueba }}</strong>
                    <input class="float check_serv" type="checkbox" :checked="serv.selected"
                           v-model="getServArray[index]['selected']" name="" id="">
                    <input placeholder="P. Tab" class="float required scr-input" type="text"
                           v-model="getServArray[index]['price_tab']" name="" id="">
                    <input placeholder="P. Com" class="float required scr-input" type="text"
                           v-model="getServArray[index]['price_com']" name="" id="">
                    <input placeholder="Desc." class="float required scr-input" type="text"
                           v-model="getServArray[index]['desc']" name="" id=""><br>

                </li>
            </ul>
        </form>
        <div class="row">
            <div class="col-md-12">
                <button id="dyn-button" class="btn btn-primary" v-on:click="guardar()">{{ tituloBtn }}</button>
            </div>
        </div>


    </div>
</template>
<script>

import {myMixins} from "../mixins/myMixins";
import {testlabhospService} from "../../Services/Testlabhosp.service";
import {relservicessupplierService} from "../../Services/RelServicesSupplier.service";

export default {
    name: "Relacion_servicios_y_proveedores",
    mixins: [myMixins],
    props: {
        role_id: {
            type: Number,
            required: true
        },
        supplier_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            filter: null,
            modificar: false,
            emptytable: false,
            isBusy: false,
            selectService: {
                where: [{
                    field: 'roles_id',
                    operator: '=',
                    value: this.role_id
                }]
            },
            relServices: {
                supplier_id: this.supplier_id,
                role_id: this.role_id,
                servicesArray: []
            },

            getServArray: [],
            currentFilterServ: [],
            tituloBtn: 'Agregar',
            resp: '',
        }
    },
    methods: {
        async updateRel() {
            this.tituloBtn = 'Actualizar';
            this.modificar = true;
            let resp = '';
            let i = 0;
            if (this.role_id === 7) {
                this.selectService.where.push({
                    field: 'id',
                    operator: '=',
                    value: 10
                }, {
                    field: 'id',
                    operator: '=',
                    value: 12
                });
            }
            resp = await testlabhospService.getMany(this.selectService);

            for (let servicios of resp) {
                //console.log('servicios id = ' + servicios.id);
                for (const selectedServ of this.currentFilterServ) {
                    //console.log('pruebalab_id = ' + selectedServ.pruebalab_id);
                    if (servicios.id == selectedServ.pruebalab_id) {
                        //console.log('se cumple la igualdad ');
                        servicios.selected = true;
                        servicios.price_tab = selectedServ.price_tab;
                        servicios.price_com = selectedServ.price_com;
                        servicios.desc = selectedServ.desc;
                        i++;
                    }
                }
            }
            this.getServArray = resp;
        },
        async getData() {
            if (this.role_id === 7) {
                this.selectService.where.push({
                    field: 'id',
                    operator: '=',
                    value: 10
                }, {
                    field: 'id',
                    operator: '=',
                    value: 12
                });
            }

            this.getServArray = await testlabhospService.getMany(this.selectService);
        },
        async index() {
            this.isBusy = true;
            this.selectService.limit = 0;

            //CHECAR SI EXISTE UNA RELACION CON EL PROVEEDOR
            let resp = await relservicessupplierService.getMany({
                where: [{
                    field: 'role_id',
                    operator: '=',
                    value: this.role_id
                }, {
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id
                }]
            });

            if (resp.length > 0) {
                this.currentFilterServ = resp;
                await this.updateRel();
            } else {
                await this.getData();
            }

            this.isBusy = false;
        },
        async guardar() {

            //INSERTAR
            let resp = '';
            this.disableSubmitBtn(true);
            for (let servicio of this.getServArray) {
                if (servicio.selected) {
                    this.relServices.servicesArray.push(
                        {
                            role_id: this.role_id,
                            pruebalab_id: servicio.id,
                            price_tab: servicio.price_tab,
                            price_com: servicio.price_com,
                            desc: servicio.desc
                        });
                }
            }
            this.disableSubmitBtn(false);
            if (this.modificar) {
                //console.log('update data = ' + JSON.stringify(this.relServices));
                resp = await relservicessupplierService.updateOne(this.relServices.supplier_id, this.relServices);
            } else {
                resp = await relservicessupplierService.saveOne(this.relServices);
            }
            this.modificar = false;
            if (resp.process === 'success') {

                this.relServices = {};
                this.getAlert(resp.process);
                this.setEmpty();
            } else {
                this.getAlert(resp.process);
            }

        },
        setEmpty() {
            this.relServices = {
                dentist_id: 0,
                servicesArray: []
            };
        }
    },
    mounted() {
        this.index();
    },
}
</script>
<style scoped>
form strong {
    display: block;
    margin-bottom: 5px;
    margin-top: 10px;
}

form input + input {
    margin-left: 5px;
}

form .scr-input {
    height: 45px;
    width: 100px;
}
</style>
